import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Button from '../../../UniformComponents/Button'
import PublishConfirmationModal from '../Modals/PublishConfirmationModal'

@observer
export default class PublishBanner extends Component {
    constructor(props) {
        super(props)
        this.state = { showModal: false }
    }

    handleClose = () => { this.setState({ showModal: false }) }

    render() {
        const { store } = this.props
        const { isTemplatePublished } = store.survey.metadata
        const { showModal } = this.state
        return (
            <div id="publishBanner">
                <div className="inner-container">
                    <div className="left-label">
                        <i className="fal fa-window-restore" />
                        <p>{i18n.t('s_template_banner_title')}</p>
                    </div>
                    <div className="publish-btn-container">
                        <Button
                            cssClass="regular"
                            variant="warning"
                            icon="fa-regular fa-paper-plane-top"
                            style={{ width: '185px', justifyContent: 'center' }}
                            onClick={() => this.setState({ showModal: true })}
                            label={i18n.t(`surveyBuilder.banner.${isTemplatePublished
                                ? 'unpublishTemplate'
                                : 'publishTemplate'
                            }`)}
                        />
                    </div>
                </div>
                <PublishConfirmationModal store={store} show={showModal} handleClose={this.handleClose} />
            </div>
        )
    }
}
